import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import TopBar from "@/components/TopBar";
import DailyBriefing from "@/pages/DailyBriefing";
import Explainability from "@/pages/Explainability";
import Quality from "@/pages/Quality";
import AuditLog from "@/pages/AuditLog";
import CommitmentRisk from "@/pages/CommitmentRisk";
import Suppliers from "@/pages/Suppliers";
import AssetMemo from "@/pages/AssetMemo";
import Genealogy from "@/pages/Genealogy";
import SignIn from "@/pages/SignIn";
import { PersonaProvider, usePersona } from "@/context/PersonaContext";

function Shell({ children }) {
  return (
    <div className="min-h-screen" style={{ background: "var(--mos-bg)" }}>
      <TopBar />
      <main className="max-w-[1240px] mx-auto px-10 py-10 mos-fade">
        {children}
      </main>
    </div>
  );
}

function RequireSignIn({ children }) {
  const { active } = usePersona();
  const location = useLocation();
  if (!active) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route
        path="/"
        element={
          <RequireSignIn>
            <Shell>
              <DailyBriefing />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/reasoning"
        element={
          <RequireSignIn>
            <Shell>
              <Explainability />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/quality"
        element={
          <RequireSignIn>
            <Shell>
              <Quality />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/quality/crosswalk"
        element={
          <RequireSignIn>
            <Shell>
              <Quality />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/risk"
        element={
          <RequireSignIn>
            <Shell>
              <CommitmentRisk />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/suppliers"
        element={
          <RequireSignIn>
            <Shell>
              <Suppliers />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/assets"
        element={
          <RequireSignIn>
            <Shell>
              <AssetMemo />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/genealogy"
        element={
          <RequireSignIn>
            <Shell>
              <Genealogy />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route
        path="/audit"
        element={
          <RequireSignIn>
            <Shell>
              <AuditLog />
            </Shell>
          </RequireSignIn>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <PersonaProvider>
        <AppRoutes />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0F172A",
              color: "#F8FAFC",
              border: "1px solid #1E293B",
              fontFamily: "IBM Plex Sans, sans-serif",
              fontSize: "13px",
            },
          }}
        />
      </PersonaProvider>
    </BrowserRouter>
  );
}
